export default genericCloudflareProvider(ASSET_BASE_PATH);
